export const ACTION_BUTTONS = {
  PRINT: 'print',
  SHARE: 'share',
  SIGN_UP: 'signUp',
  ACTION: 'action',
  ADD_TO_COLLECTION: 'addToCollection',
  BOOKMARK: 'bookmark'
};
